import { IPermission } from "../interfaces/Permission.interface";
import mongoose, { Model, Schema } from "mongoose";

const PermissionSchema = new Schema<IPermission>({
    name: { type: String },
    description: { type: String },
    isActive: { type: Boolean, default: true },
    slug: { type: String, unique: true }
}, { timestamps: true, versionKey: false })


PermissionSchema.pre('save', function (next) {
    if (!this.slug && this.name) {
        this.slug = this.name.toLowerCase().replace(/\s+/g, '-');
    }
    next();
});
const Permission: Model<IPermission> = mongoose.model<IPermission>('Permissions', PermissionSchema)
export default Permission
